import { z } from 'zod'

export const campaignDetailsValidationSchema = z.object({
	title: z.string().min(2, 'Title must be at least 2 characters'),
	location: z.string().min(1, 'Location is required'),
	language: z.string().min(2, 'Language is required'),
	requirements: z.string().min(4, 'Description must be at least 4 characters'),
})

export const campaignUrlValidationSchema = z.object({
	url: z.string().url('Must be a valid URL'),
})

export type CampaignDetailsValidation = z.infer<typeof campaignDetailsValidationSchema>
export type CampaignUrlValidation = z.infer<typeof campaignUrlValidationSchema>
